import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DxTextAreaComponent } from 'devextreme-angular';

@Component({
  selector: 'app-dialog-edit-text',
  templateUrl: './dialog-edit-text.component.html',
  styleUrls: ['./dialog-edit-text.component.scss'],
  standalone: false,
})
export class DialogEditTextComponent implements OnInit {
  translate = inject(TranslateService);

  @ViewChild('textAreaComponent', { read: DxTextAreaComponent, static: false }) textAreaComponent;

  private eventChange$: Observable<boolean>;
  private _observer: Observer<boolean>;
  showDialog: boolean = false;
  caption: string;
  title: string;
  value: string;

  constructor() {
    this.eventChange$ = new Observable<boolean>(observer => (this._observer = observer));
  }

  ngOnInit() {}

  execute(caption: string, title: string, value: string): Observable<boolean> {
    var that = this;
    setTimeout(function () {
      that.textAreaComponent.instance.focus();
    }, 100);

    this.caption = caption;
    this.title = title;
    this.value = value;
    this.showDialog = true;
    return this.eventChange$;
  }

  onConfirm() {
    this._observer.next(true);
    this.showDialog = false;
  }

  onCancel() {
    this._observer.next(false);
    this.showDialog = false;
  }
}
